let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8tYz2")).then(() => parcelRequire('iPJbm'));